import { Button, Space } from "antd";
import InfoIcon from "../../../../assets/icons/InfoIcon";
import CustomModal from "../../../../components/ui/CustomModal";
import { ModalComponentProps } from "../../../../types";

type ConfirmActionModalProps = ModalComponentProps & {
  handleAction?: () => void;
};

export default function RidirectUserAccessPerModal({
  handleClose,
  type,
  data,
  handleAction,
  ...rest
}: ConfirmActionModalProps) {
  return (
    <CustomModal {...rest} handleClose={handleClose} width={400} footer={null}>
      <div className="flex items-center gap-2">
        <span className="bg-[#FFF6ED] p-1 rounded">
          <InfoIcon />
        </span>
        <span className="text-[22px] font-semibold">
          User Access Permission
        </span>
      </div>

      <div className="self-stretch justify-start text-slate-500 text-base font-normal leading-7 mt-3 mb-3">
        Do you want to assign a product to this user?
      </div>

      <Space className="w-full mt-2" size={12}>
        <Button
          className="normal-dark-button modal-button !h-[40px]"
          onClick={handleClose}
          size="middle"
        >
          Cancel
        </Button>
        <Button
          className="modal-button !h-[40px]"
          type="primary"
          htmlType="submit"
          size="middle"
          onClick={handleAction}
        >
          Yes, Assign Product
        </Button>
      </Space>
    </CustomModal>
  );
}
